/*
 * Customer Messages
 *
 * This contains all the text for the Staff container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.Customer';

export default defineMessages({
  header: {
    id: `${scope}.destination`,
    defaultMessage: 'This is the Customer container!',
  },
  insegna: {
    id: `${scope}.Insegna`,
    defaultMessage: 'Insegna',
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Customers',
  },
  new_customer: {
    id: `${scope}.new_customer`,
    defaultMessage: 'New customer',
  },
  customerCode: {
    id: `${scope}.customerCode`,
    defaultMessage: 'Cust. Code',
  },
  code: {
    id: `${scope}.code`,
    defaultMessage: 'Code',
  },
  destinationState: {
    id: `${scope}.destinationState`,
    defaultMessage: 'Dest. State',
  },
  destinationCode: {
    id: `${scope}.destinationCode`,
    defaultMessage: 'Dest. Code',
  },
  businessName: {
    id: `${scope}.businessName`,
    defaultMessage: 'Dest. Area',
  },
  destinationLogisticArea: {
    id: `${scope}.destinationLogisticArea`,
    defaultMessage: 'Customer Dest. Logistic Area',
  },
  businessCity: {
    id: `${scope}.businessCity`,
    defaultMessage: 'City',
  },
  businessProvince: {
    id: `${scope}.businessProvince`,
    defaultMessage: 'Province',
  },
  businessCountry: {
    id: `${scope}.businessCountry`,
    defaultMessage: 'Country',
  },
  nominative: {
    id: `${scope}.nominative`,
    defaultMessage: 'Nominative',
  },
  export_pdf: {
    id: `${scope}.export_pdf`,
    defaultMessage: 'Export PDF',
  },
  address: {
    id: `${scope}.address`,
    defaultMessage: 'Address',
  },
  prospect: {
    id: `${scope}.prospect`,
    defaultMessage: 'Prospect',
  },
  customer: {
    id: `${scope}.client`,
    defaultMessage: 'Customer',
  },
  phone: {
    id: `${scope}.phone`,
    defaultMessage: 'phone',
  },
  agent: {
    id: `${scope}.agent`,
    defaultMessage: 'Agent',
  },
  isActive: {
    id: `${scope}.isActive`,
    defaultMessage: 'Is active?',
  },
  yes: {
    id: `${scope}.yes`,
    defaultMessage: 'Yes',
  },
  onlyMine: {
    id: `${scope}.onlyMine`,
    defaultMessage: 'Only mine',
  },
  ACTIVE: {
    id: `${scope}.active`,
    defaultMessage: 'Active',
  },
  INACTIVE: {
    id: `${scope}.inactive`,
    defaultMessage: 'Inactive',
  },
  lastAction: {
    id: `${scope}.lastAction`,
    defaultMessage: 'Last action',
  },
  shopSign: {
    id: `${scope}.shopSign`,
    defaultMessage: 'Shop sign',
  },
});
